import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
    Row,
    Card,
    Form,
    Select,
    Input,
    DatePicker,
    Col,
    Divider,
    Spin,
    Typography,
    InputNumber
} from "antd";

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import CustomButton from "../../../../../../components/custom/CustomButton";
import MainLayout from "../../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../../../group.config";
import styles from "../../../../../../assets/styles/styles";

const dateFormat = 'YYYY/MM/DD';

const AddCharge = (props) => {
    const { userData } = props;
    const { session } = userData;
    const navigate = useNavigate();
    const [useForm] = Form.useForm();
    const { state } = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [chargesOptions, setChargesOptions] = useState([]);
    const [displayFields, setDisplayFields] = useState(false);
    const [productDetail, setProductDetail] = useState([]);
    const [chargeId, setChargeId] = useState();
    const [showDate, setShowDate] = useState(false);

    useEffect(() => {
        getTemplate();
    }, []);

    function onCancel() {
        navigate("/detail-group-savings", { state: state });
    }
    const getTemplate = () => {

        const url = `${apiConfig.SavingsAccounts}/${state.id}/charges/template`;

        let body = {
            session,
        };
        setIsLoading(true);

        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                setIsLoading(false);
            } else {
                const objDetail = res;
                let tempCharges = [];

                objDetail?.chargeOptions?.forEach((element) => {
                    tempCharges.push({
                        value: element.id,
                        label: element.name ? `${element.name} (${element.currency.name})` : "",
                    });
                });
                setChargesOptions(tempCharges);
                setIsLoading(false);
            }
        });
    };
    const onChangeProduct = (productParam) => {
        getDetailById(productParam);

        setDisplayFields(true);
    }
    const getDetailById = (productParam) => {
        const params = {
            template: true,
        }
        const url = `${apiConfig.Charges}/${productParam}`;
        let body = {
            session,
            params
        };
        setIsLoading(true);

        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                setIsLoading(false);
            } else {
                const objDetail = res;
                switch (objDetail?.chargeTimeType?.value.toLowerCase()) {
                    case "monthly fee":
                    case "weekly fee":
                    case "specified due date":
                    case "annual fee":
                        setShowDate(true)
                        break;
                    default:
                        setShowDate(false)
                        break;
                }
                useForm.setFieldsValue({
                    amount: objDetail.amount,
                    chargeCalculationType: objDetail?.chargeCalculationType?.value,
                    chargeTimeType: objDetail?.chargeTimeType?.value,
                });

                setChargeId(productParam)
                setIsLoading(false);
            }
        });
    }
    const onSubmit = (formValues) => {
        const url = `${apiConfig.SavingsAccounts}/${state.id}/charges`;

        const body = formValues?.dueDate ?
            {
                amount: formValues.amount,
                dueDate: BOM.DateTime(
                    formValues.dueDate,
                    "only-date"
                ),
                dateFormat: "dd MMMM yyyy",
                chargeId,
                locale: "en",
                method: "POST",
                session,
            } : {
                amount: formValues.amount,
                chargeId,
                locale: "en",
                method: "POST",
                session,
            };
        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                setIsLoading(false);
            } else {
                BOM.AlertMsg(cnt.SUCCESS, labelConfig.addChargesSavingsGrpMsg);
                navigate("/detail-group-savings", {
                    state: { ...state, statusValue: state?.status?.value.toLowerCase() },
                });

                //STOP LOAD
                setIsLoading(false);
            }
        });
    };

    return (
        <MainLayout isEnableRightSidebar={true}>
            <TopContent
                pageTitle={labelConfig.addChargesSavingsGrp}
                pageItems={staticConfig.addChargeSavingsGrpBreadcrumbItems}
            />

            <Spin spinning={isLoading} size="large">
                <Card
                    headStyle={{ borderBottomWidth: 0 }}
                    style={{
                        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                        borderRadius: 20,
                    }}
                >
                    <Form form={useForm} layout="vertical" onFinish={onSubmit}>
                        <Row>
                            <Divider orientation="left">{`Account No: ${state.accountNo}`}</Divider>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.charges}
                                    name="charges"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld("Charges"),
                                        },
                                    ]}
                                >
                                    <Select
                                        filterOption={(input, option) =>
                                            (option?.label?.toLowerCase() ?? "").includes(
                                                input?.toLowerCase()
                                            )
                                        }
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.charges,
                                            "select"
                                        )}
                                        onChange={onChangeProduct}
                                        options={chargesOptions}
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>
                            {
                                displayFields && (
                                    <>
                                        <Col span={8} style={{ padding: "0px 8px" }}>
                                            <Form.Item
                                                label={
                                                    <Typography.Text style={{ fontSize: "16px" }}>
                                                        {labelConfig.amount}
                                                    </Typography.Text>
                                                }
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: BOM.CheckReqFld("Charges"),
                                                    },
                                                ]}
                                                name="amount"
                                            >
                                                <InputNumber
                                                    defaultValue={productDetail?.amount ?
                                                        productDetail?.amount : "-"
                                                    }
                                                    style={styles.ofInputFieldNumber}

                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8} style={{ padding: "0px 8px" }}>
                                            <Form.Item
                                                label={labelConfig.chargeCalculation}
                                                name="chargeCalculationType"
                                            >
                                                <Input
                                                    disabled
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8} style={{ padding: "0px 8px" }}>
                                            <Form.Item
                                                label={labelConfig.chargeTimeType}
                                                name="chargeTimeType"
                                            >
                                                <Input
                                                    disabled
                                                />
                                            </Form.Item>
                                        </Col>
                                        {showDate &&
                                            <Col span={8} style={{ padding: "0px 8px" }}>
                                                <Form.Item
                                                    label={labelConfig.dueForCollectionOn}
                                                    name="dueDate"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: BOM.CheckReqFld(labelConfig.dueForCollectionOn),
                                                        },
                                                    ]}
                                                >
                                                    <DatePicker
                                                        disabledDate={BOM.DisabledAfterCurrentDate}
                                                        placeholder={BOM.handlePlaceholderMsg(
                                                            labelConfig.dueForCollectionOn,
                                                            "select"
                                                        )}
                                                        style={{ width: "100%", height: 35 }}
                                                        format={dateFormat}
                                                    />
                                                </Form.Item>
                                            </Col>}
                                    </>
                                )
                            }
                        </Row>

                        <Row>
                            <Divider />
                            <CustomButton
                                content="Submit"
                                style={{
                                    width: "10%",
                                    marginLeft: "auto",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                htmlType="submit"
                                backgroundColor="#15CCAE"
                                colorText="black"
                                hoverBackground="#4FECA0"
                            />

                            <CustomButton
                                content="Cancel"
                                style={{
                                    width: "10%",
                                    marginLeft: "1%",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                backgroundColor="#fff"
                                colorText="black"
                                hoverBackground="#F5F5F5"
                                onClick={onCancel}
                            />
                        </Row>
                    </Form>
                </Card>
            </Spin>
        </MainLayout>
    );
};

export default AddCharge;
